<template>
  <path
    d="M12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM12 5.00018C13.66 5.00018 15 6.34018 15 8.00018C15 9.66018 13.66 11.0002 12 11.0002C10.34 11.0002 9 9.66018 9 8.00018C9 6.34018 10.34 5.00018 12 5.00018ZM12 19.2002C9.5 19.2002 7.29 17.9202 6 15.9802C6.03 13.9902 10 12.9002 12 12.9002C13.99 12.9002 17.97 13.9902 18 15.9802C16.71 17.9202 14.5 19.2002 12 19.2002Z"
  />
</template>
